module.exports = __webpack_public_path__ + "static/img/triangle-exhibit-base-with-frames.1540050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/nps/triangle-exhibit-base-with-frames.jpg
// module id = 748
// module chunks = 0